var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "opacity": "0.7"
    }
  }, [_c('path', {
    staticClass: "ease-in-out duration-300",
    attrs: {
      "d": "M10.3438 21.6598L21.6637 10.3398",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "ease-in-out duration-300",
    attrs: {
      "d": "M10.3438 10.3398L21.6637 21.6598",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "fill": "currentColor"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }